import * as React from 'react'

function SvgIconMathDivision(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="math-division" aria-labelledby="t-math-division d-math-division">
        <title id="t-math-division">{'Division'}</title>
        <desc id="d-math-division">{'Math symbol for division'}</desc>
        <path d="M31 17H1a1 1 0 110-2h30a1 1 0 110 2zM16 6c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4c-.551 0-1 .449-1 1s.449 1 1 1a1 1 0 000-2zM16 32c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4c-.551 0-1 .448-1 1s.449 1 1 1a1 1 0 100-2z" />
      </g>
    </svg>
  )
}

export default SvgIconMathDivision
